export class OffsettersData {
  static readonly volumeDown = -0.2;
  static readonly volumeUp = 0.2;
  static readonly jumpAhead = 15;
  static readonly jumpBackward = -15;
}
